// Change the archived state of a course
export * from './archive-course';
